import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_TERMINAL_DEF,
} from "./actionTypes"

import {
    getTerminalDefListSuccess,
    terminalDefApiError
} from "./actions"

//Include Both Helper File with needed methods
import {
    GetAllTerminalDef,
} from "../../helpers/backend_helper/backend_helper"

function* onGetTerminalDefList() {
  try {
    const response = yield call(GetAllTerminalDef)
    yield put(getTerminalDefListSuccess(response))
  } catch (error) {
    yield put(terminalDefApiError(error))
  }
}

function* terminalDefSaga() {
    yield takeEvery(GET_TERMINAL_DEF,onGetTerminalDefList)
}

export default terminalDefSaga